/*
	- The theme is designed to maintain a 1:1 relationship between observer triggers and Wistia videos.

	- Each observer trigger corresponds to a specific Wistia video, ensuring precise control over video loading.
	
	- This setup allows for efficient management of video resources and ensures that videos are loaded only when they are about to become visible to the user.
*/

export default function initWistia() {
    const wistiaVideos = [...document.querySelectorAll('[data-wistia-vid-id]')]
    const observerTriggers = [...document.querySelectorAll('.trigger-observer')]

    if (observerTriggers.length > 0 && wistiaVideos.length > 0) {
        observerTriggers.forEach((trigger, index) => {
            const ob = new IntersectionObserver((entries) => {
                entries.forEach(
                    (entry) => {
                        if (entry.isIntersecting) {
                            // Attach observer to wistia video
                            const videoToLoad = wistiaVideos[index]
                            loadWistiaScripts(videoToLoad)
                            ob.unobserve(entry.target)
                            ob.disconnect()
                        }
                    },
                    { threshold: 0.25 }
                )
            })

            ob.observe(trigger)
        })
    } else {
        // loadWistiaScripts(wistiaVideos)
    }

    //  Custom Play Buttons
    if (wistiaVideos) {
        wistiaVideos.forEach((wVideo) => {
            const playBtn = wVideo.nextElementSibling

            if (!playBtn || !playBtn.classList.contains('wistia-play-btn'))
                return

            playBtn.addEventListener('click', () => {
                window._wq = window._wq || []
                _wq.push({
                    id: wVideo.dataset.wistiaVidId,
                    onReady: function (video) {
                        video.play()
                        playBtn.parentElement.classList.add('playing')
                    },
                })
            })
        })
    }
}

// // Force one video to play at a time
// export function forceSingleVideoPlay() {
//   window._wq = window._wq || [];
//   _wq.push({
//     id: "_all",
//     onReady: function (video) {
//       video.bind("play", function () {
//         var allVideos = Wistia.api.all();
//         for (var i = 0; i < allVideos.length; i++) {
//           if (allVideos[i].hashedId() !== video.hashedId()) {
//             allVideos[i].pause();
//           }
//         }
//       });
//     },
//   });
// }

// export function soundAnimate() {
//   const videoToAnimate = document.querySelector(
//     ".section-copy-video .wistia-video-container",
//   );

//   if (!videoToAnimate) return;

//   const floatingImg = videoToAnimate.querySelector(".floating-img");

//   window._wq = window._wq || [];
//   _wq.push({
//     id: videoToAnimate.dataset.wistiaVidId,
//     onReady: (video) => {
//       video.bind("mutechange", () => {
//         video.isMuted() && video.state() === "playing"
//           ? floatingImg.classList.remove("sound-on")
//           : floatingImg.classList.add("sound-on");
//       });
//     },
//   });
// }

// // NOTE: Intended to only be executed on window resize event for the copy-video seciton.
// export function moveVideoContainer() {
//   var videoContainer = document.querySelector(
//     ".section-copy-video .wistia-video-container",
//   );
//   var destination = document.querySelector(".wistia-mobile-location");

//   if (!destination) return;

//   if (window.innerWidth < 996) {
//     destination.appendChild(videoContainer);
//   }
// }

// Helpers
function loadWistiaScripts(video) {
    video.insertAdjacentHTML(
        'beforeend',
        `<div class="wistia_responsive_padding" style=""><div class="wistia_responsive_wrapper" style="height:100%;width:100%;"><div class="wistia_embed wistia_async_${video.dataset.wistiaVidId} seo=true videoFoam=true controlsVisibleOnLoad=false playButton=false playerColor=ad70c4" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/${video.dataset.wistiaVidId}/swatch" style="height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>`
    )

    // Load companion script
    let wistiaScript = document.createElement('script')
    wistiaScript.setAttribute('async', '')

    wistiaScript.src = `https://fast.wistia.com/embed/medias/${video.dataset.wistiaVidId}.jsonp`

    document.body.append(wistiaScript)
}
